<template>
  <div v-show="isLoaded" class="mOthersGold-container" v-observe-visibility="startAnimate">
    <div class="mOthersGold-title">
      <h2 class="Others-title" :class="{animate: animate}">Conoce <br> <span class="title-span">Otros <span class="subtitle-span">Sabores</span></span></h2>
    </div>
    <div class="mOthersGold-sku">
      <div class="mRow">
        <router-link
          :to="{name: 'redBerries'}"
          :class="{animate: animate}"
        >
          <img class="bottle-mobile" :src="redberries" alt="Red Berries" />
          <img class="bottle-desktop" :src="desktopred" alt="Red Berries" />    
        </router-link>
        <router-link
          :to="{name: 'honey'}"
          :class="{animate: animate}"
        >
          <img class="bottle-mobile" :src="honey" alt="Honey" />
          <img class="bottle-desktop" :src="desktophoney" alt="Honey" />  
        </router-link>
        <router-link
          :to="{name: 'roseApple'}"
          :class="{animate: animate}"
        >
          <img class="bottle-mobile" :src="rose" alt="Rosé Apple" />
          <img class="bottle-desktop" :src="desktoprose" alt="Rosé Apple" />   
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import redberries from "@/assets/RED_BERRIES.png";
import honey from "@/assets/HONEY.png";
import rose from "@/assets/ROSE.png";
import desktopred from "@/assets/desktop_redberries.png"
import desktoprose from "@/assets/desktop_roseapple.png"
import desktophoney from "@/assets/desktop_honey.png"
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
  name: "OthersGold",
  data() {
    return {
      redberries,
      honey,
      rose,
      desktopred,
      desktoprose,
      desktophoney,
      animate: false,
      isSafari: false,
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      } 
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/GoldApple/OthersGold.scss";
</style>
